import { Component } from '@angular/core';

@Component({
    selector: 'nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.css'],
    standalone: false
})
export class NavBarComponent {

  activeSection: string = 'home';


  selectSection(event: Event, sectionId: string) {
    event.preventDefault();
    this.activeSection = sectionId;
  }

}
